module.exports = __webpack_public_path__ + "49d23185a5f25e1d8c0305b39dcaef8c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Yummy/images/backgrounds/4.png
// module id = 34
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18